(function($) {
  /**
   * Add Leading Zero to Number Input
   */
  function addLeadingZero(input) {
    if (!input.length) {
      return false;
    }

    if (input.val().length === 1) {
      var value = input.val();
      input.val('0' + input.val());
    }
  }

  /**
   * Custom Fields - Length
   */
  $('.wpcf7 .col-length').each(function () {
    $(this).find('input[type="number"]').each(function () {
      $(this).on('change', function () {
        addLeadingZero($(this));
      });

      addLeadingZero($(this));
    });
  });

  /**
   * Custom Fields - Multiple files
   */
  var filesInput = $('.wpcf7 #files');

  if (filesInput.length) {
    var filesOuput = filesInput.next('#files-output');

    filesInput.on('change', function () {
      filesOuput.html('');

      var children = '';
      for (var i = 0; i < filesInput[0].files.length; ++i) {
        children += '<li>' + filesInput[0].files.item(i).name + '</li>';
      }

      filesOuput.html('<ul>'+children+'</ul>');
    });
  }
})(jQuery);